import { render, staticRenderFns } from "./config_apply.vue?vue&type=template&id=37270a2f&scoped=true&"
import script from "./config_apply.vue?vue&type=script&lang=js&"
export * from "./config_apply.vue?vue&type=script&lang=js&"
import style0 from "./config_apply.vue?vue&type=style&index=0&id=37270a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37270a2f",
  null
  
)

export default component.exports